import termsSlice from './slice';

export const { openTermsModal, closeTermsModal } = termsSlice.actions;
